import React, { useEffect, useRef } from "react"
import * as Chart from "chart.js"
import { translations } from "../../utils/Translation/staticTranslation"

const MerchantSubscription = () => {
  const chartRef = useRef(null)
  const chartInstance = useRef(null)

  const lang = localStorage.getItem("language") || "ar"
  const dashboardAdmin = translations[lang]?.DashboardSuperAdmin

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy()
    }

    const ctx = chartRef.current.getContext("2d")

    chartInstance.current = new Chart.Chart(ctx, {
      type: "doughnut",
      data: {
        labels: ["Free", "Standard", "Enterprise"],
        datasets: [
          {
            data: [60, 30, 10],
            backgroundColor: [
              "rgba(147, 176, 255, 0.8)",
              "rgba(136, 108, 192, 0.8)",
              "rgba(255, 178, 84, 0.8)",
            ],
            borderColor: [
              "rgba(147, 176, 255, 1)",
              "rgba(136, 108, 192, 1)",
              "rgba(255, 178, 84, 1)",
            ],
            borderWidth: 1,
            hoverOffset: 5,
          },
        ],
      },
      options: {
        cutoutPercentage: 60,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return `${context.label}: ${context.raw}%`
              },
            },
          },
        },
        responsive: true,
        maintainAspectRatio: true,
      },
    })

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy()
      }
    }
  }, [])

  const legendItems = [
    {
      color: "rgba(147, 176, 255, 0.8)",
      label: dashboardAdmin?.subscription_overview_description_1,
    },
    {
      color: "rgba(136, 108, 192, 0.8)",
      label: dashboardAdmin?.subscription_overview_description_2,
    },
    {
      color: "rgba(255, 178, 84, 0.8)",
      label: dashboardAdmin?.subscription_overview_description_3,
    },
  ]

  return (
    <div
      className="h-100 w-100"
      style={{
        display: "grid",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        maxWidth: "358px",
      }}
    >
      <h2 className="text-xl font-semibold text-start text-141414 text-18 font-600 mb-3">
        {dashboardAdmin?.subscription_overview}
      </h2>

      <div className="relative mx-auto" style={{ height: "200px" }}>
        <canvas ref={chartRef} />
      </div>

      <div className="mt-3">
        {legendItems.map((item, index) => (
          <div key={index} className="d-flex">
            <div
              style={{
                backgroundColor: item.color,
                width: "100%",
                height: "12px",
                borderRadius: "2px",
                maxWidth: "12px",
                marginTop: "5px",
              }}
              className={` ${lang === "ar" ? "ml-5" : "mr-5"} `}
            />
            <p
              className={`text-14 text-2E2E30 ${
                lang === "ar" ? "ml-10" : "mr-10"
              }`}
            >
              {/* <p> */}
              {item.label}
              {/* </p> */}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MerchantSubscription
